/**
 * /orgs/:orgId/secrets — the tenant's secret values.
 *
 * Values resolved at task submission; an unset key falls back to the
 * platform-wide value managed under Security.
 */
import { useRequiredOrgId } from '../../lib/use-current-org.js';
import { ListShape } from '../../ui/shapes.js';
import { OrgSecretsEditor } from '../organizations/OrgSecretsEditor.js';

export function OrgSecretsPage() {
  const orgId = useRequiredOrgId();
  return (
    <ListShape
      title="Secrets"
      subtitle="Values resolved at task submission. Unset keys fall back to the platform store."
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 22, paddingBottom: 64 }}>
        <OrgSecretsEditor organizationId={orgId} />
      </div>
    </ListShape>
  );
}
